import React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"

import PagingDots from "../PagingDots/PagingDots"

import styles from "./QuizIntro.module.scss"
import { sendGTMEvent } from "../../utils/googleAnalytics"

const QuizIntro = ({ data, fansidedLogo, quizLength, onClick }) => (
    <div className={styles.container}>
        <div className={styles.header}>
            <a
                href="https://hiddenremote.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                <img src={fansidedLogo} alt="FanSided Logo" />
            </a>
        </div>
        <StaticImage
            src={"../../images/quiz-hero-image.png"}
            className={styles.heroImage}
            alt="Quiz"
        />
        <h2 className={styles.quizName}>{data.name}</h2>

        <p className={styles.quizText}>{data.text}</p>
        <div>
            <button
                className={styles.startButton}
                onClick={() => {
                    sendGTMEvent("widget start click")
                    onClick()
                }}
            >
                Start
            </button>
        </div>
        <div className={styles.pagingDotContainer}>
            <PagingDots slideCount={quizLength} currentSlide={0} disable />
        </div>
    </div>
)

QuizIntro.propTypes = {
    data: PropTypes.shape({
        date: PropTypes.string.isRequired,
        image: PropTypes.shape({
            width: PropTypes.string.isRequired,
            height: PropTypes.string.isRequired,
        }),
        name: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        shareText: PropTypes.string.isRequired,
        styles: PropTypes.shape({
            darkerColor: PropTypes.string.isRequired,
            lighterColor: PropTypes.string.isRequired,
        }).isRequired,
    }),
    fansidedLogo: PropTypes.string.isRequired,
    quizLength: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
}

export default QuizIntro
